// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================== Invoice =================== */
.invoice-wrap {
  max-width: 100%;
  margin: 28px auto;
  padding: 28px;
}

.invoice {
  background: var(--card);
  border-radius: 18px;
  padding: 34px;
  direction: rtl;
}

.brand small {
  color: var(--muted);
  margin-top: 6px;
}

.logo {
  width: 72px;
  height: 72px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--soft);
  font-weight: 700;
}

.top-card {
  background: var(--soft);
  padding: 14px 18px;
  border-radius: 12px;
  display: flex;
  gap: 12px;
  align-items: center;
}

.top-card .col {
  min-width: 120px;
}

.top-row {
  margin-top: 26px;
  display: flex;
  gap: 18px;
}

.summary {
  margin-top: 18px;
  width: 320px;
  float: left;
  background: var(--card);
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 4px 14px rgba(2, 6, 23, 0.04);
}

.summary .row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f1f4f8;
}

.summary .row:last-child {
  border-bottom: none;
}

.total {
  font-weight: 700;
  color: var(--accent);
}

.footer {
  clear: both;
  margin-top: 120px;
  text-align: center;
  color: var(--muted);
  font-size: 13px;
  padding-top: 20px;
  border-top: 1px solid #f2f5f9;
}

/* =================== Invoice Container =================== */
.invoice-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.invoice-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: start;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  width: 100%;
}

.invoice-total {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: right;
  background-color: #EA6C22;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  color: #fff;
}

.company-name {
  font-size: 16px;
  font-weight: bold;
  color: #1a2b5c;
}

.company-location {
  font-size: 13px;
  color: #777;
}

/* =================== Invoice Top =================== */
.invoice-top {
  display: flex;
  align-items: center;
  justify-content: space-between; /* لوگو راست، دکمه چپ */
  gap: 20px;
  flex-wrap: nowrap; /* همیشه کنار هم بمونن */
  margin-bottom: 30px;
}

.invoice-logo {
  order: 1;
}

.invoice-details {
  order: 2;
  flex: 1 1; /* کشیده میشه تا وسط قرار بگیره */
  display: flex;
  justify-content: center;
  gap: 60px;
  text-align: center;
}

.invoice-print-btn-container {
  order: 3;
}

.invoice-print-btn {
  background: #EA6C22;
  color: #fff;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.invoice-print-btn:hover {
  background: #d45a1d;
}

.invoice-col {
  display: flex;
  flex-direction: column;
}

.invoice-col .label {
  font-size: 12px;
  color: #8790a6;
  margin-bottom: 4px;
}

.invoice-col .value {
  font-weight: 700;
  font-size: 14px;
  color: #222;
}

.payment-item {
  background: #d8d8d8;
  padding: 10px;
  margin-bottom: 30px;
  border-radius: 8px;
}

/* =================== Dashboard & Cards =================== */
.dashboard-container {
  display: flex;
  flex-direction: column; 
  gap: 24px;
  padding: 60px 20px;
  background-color: #ffffff;
  border-radius: 16px;
  margin: 20px auto;
  direction: rtl;
  text-align: right;
}

.cards-row {
  display: flex;
  gap: 16px;
}

.card22 {
  flex: 1 1;
  padding: 20px;
  border-radius: 12px;
  background-color: #F6F8FC;
  display: flex;
  flex-direction: column;
  text-align: right;
  border: 1px solid #EBEFF6;
  position: relative;
}

.label-cards {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #555;
  margin-bottom: 16px;
}

.left-card {
  background: linear-gradient(135deg, #ff7a45, #ff5c00);
  color: white;
  box-shadow: rgba(255, 89, 0, 0.5) 0px 18px 50px -10px;
}

.header33 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 500;
  direction: rtl;
}

.checkmark {
  font-size: 14px;
  color: #4CAF50;
}

.content {
  text-align: right;
}

.amount {
  font-size: 32px;
  font-weight: bold;
  margin: 10px 0;
  text-align: center;
  margin-top: 40px;
}

.count {
  font-size: 14px;
  opacity: 0.8;
  margin-top: 8px;
}

.company-name,
.support-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
}

.contact-info,
.phone,
.address {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 8px 0;
}

.address {
  font-size: 12px;
  color: #777;
}

.support-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  font-size: 18px;
}

/* =================== Pricing Table =================== */
.uniqueTableWrapper_8kL2m {
  max-width: 700px;
  margin: 30px auto;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.07);
  border: 1px solid #eef2f7;
  font-family: 'Segoe UI', Tahoma, sans-serif;
}

.uniqueStyledTable_3pQ9r {
  width: 100%;
  border-collapse: collapse;
  direction: rtl;
}

.uniqueStyledTable_3pQ9r th {
  background: #f8fafc;
  padding: 16px 20px;
  text-align: center;
  font-weight: 700;
  color: #1e293b;
  font-size: 15px;
  border-bottom: 2px solid #e2e8f0;
}

.uniqueStyledTable_3pQ9r td {
  padding: 16px 20px;
  text-align: center;
  color: #475569;
  border-bottom: 1px solid #f1f5f9;
}

.uniqueStyledTable_3pQ9r tr:last-child td {
  border-bottom: none;
}

.uniqueStyledTable_3pQ9r tr:hover td {
  background: #f9fafb;
}

.uniqueNameCell_7xR4t {
  font-weight: 600;
  color: #0f172a;
  text-align: right !important;
}

.uniqueTotalCell_2aB8c {
  font-weight: 700;
  color: #0d9488;
}

/* =================== Responsive =================== */
@media (max-width: 768px) {
  .dashboard-container {
    flex-direction: column;
    padding: 12px;
    gap: 20px;
  }

  .cards-row {
    flex-direction: column; /* کارت‌ها زیر هم */
    gap: 16px;
  }

  .card22 {
    width: 100%;
    padding: 16px;
    min-height: auto;
  }

  .amount {
    font-size: 24px;
  }

  .company-name,
  .support-title {
    font-size: 16px;
  }
}

@media (max-width: 720px) {
  .invoice-wrap {
    padding: 16px;
  }

  .invoice {
    padding: 20px;
  }

  .summary {
    float: none;
    width: 100%;
  }

  .invoice-top {
    gap: 10px; /* کاهش فاصله */
        flex-direction: column;

  }

  .invoice-details {
    gap: 20px;
        flex-direction: column;

  }

  .invoice-print-btn {
    padding: 8px 12px;
    font-size: 13px;
  }
}

@media (max-width: 600px) {
  .uniqueStyledTable_3pQ9r,
  .uniqueStyledTable_3pQ9r thead,
  .uniqueStyledTable_3pQ9r tbody,
  .uniqueStyledTable_3pQ9r th,
  .uniqueStyledTable_3pQ9r td,
  .uniqueStyledTable_3pQ9r tr {
    display: block;
  }

  .uniqueStyledTable_3pQ9r thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .uniqueStyledTable_3pQ9r tr {
    border: 1px solid #edf2f7;
    margin-bottom: 12px;
    border-radius: 12px;
    padding: 16px;
    background: #fff;
  }

  .uniqueStyledTable_3pQ9r td {
    text-align: right !important;
    border: none;
    position: relative;
    padding-right: 90px !important;
    padding-left: 12px !important;
    min-height: 26px;
  }

  .uniqueStyledTable_3pQ9r td:before {
    content: attr(data-label) ": ";
    position: absolute;
    right: auto;
    left: 12px;
    font-weight: 600;
    color: #475569;
    font-size: 13px;
  }

  .uniqueNameCell_7xR4t:before {
    color: #1e293b;
  }

  .uniqueTotalCell_2aB8c:before {
    color: #0d9488;
  }
}





.invoice-share-btn-container {
  display: none;
}

@media (max-width: 768px) {
  .invoice-share-btn-container {
    display: block;
    margin-top: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Invoice/Invoice.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAE,uBAAuB;EACvD,SAAS;EACT,iBAAiB,EAAE,wBAAwB;EAC3C,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,SAAO,EAAE,iCAAiC;EAC1C,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,sBAAsB,EAAE,mBAAmB;IAC3C,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,SAAS,EAAE,eAAe;QACtB,sBAAsB;;EAE5B;;EAEA;IACE,SAAS;QACL,sBAAsB;;EAE5B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;;;;;AAMA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":["/* =================== Invoice =================== */\n.invoice-wrap {\n  max-width: 100%;\n  margin: 28px auto;\n  padding: 28px;\n}\n\n.invoice {\n  background: var(--card);\n  border-radius: 18px;\n  padding: 34px;\n  direction: rtl;\n}\n\n.brand small {\n  color: var(--muted);\n  margin-top: 6px;\n}\n\n.logo {\n  width: 72px;\n  height: 72px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--soft);\n  font-weight: 700;\n}\n\n.top-card {\n  background: var(--soft);\n  padding: 14px 18px;\n  border-radius: 12px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.top-card .col {\n  min-width: 120px;\n}\n\n.top-row {\n  margin-top: 26px;\n  display: flex;\n  gap: 18px;\n}\n\n.summary {\n  margin-top: 18px;\n  width: 320px;\n  float: left;\n  background: var(--card);\n  border-radius: 8px;\n  padding: 12px 14px;\n  box-shadow: 0 4px 14px rgba(2, 6, 23, 0.04);\n}\n\n.summary .row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #f1f4f8;\n}\n\n.summary .row:last-child {\n  border-bottom: none;\n}\n\n.total {\n  font-weight: 700;\n  color: var(--accent);\n}\n\n.footer {\n  clear: both;\n  margin-top: 120px;\n  text-align: center;\n  color: var(--muted);\n  font-size: 13px;\n  padding-top: 20px;\n  border-top: 1px solid #f2f5f9;\n}\n\n/* =================== Invoice Container =================== */\n.invoice-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.invoice-card {\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: start;\n  align-items: flex-start;\n  gap: 15px;\n  padding: 15px;\n  width: 100%;\n}\n\n.invoice-total {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-align: right;\n  background-color: #EA6C22;\n  padding: 20px;\n  border-radius: 8px;\n  width: 100%;\n  color: #fff;\n}\n\n.company-name {\n  font-size: 16px;\n  font-weight: bold;\n  color: #1a2b5c;\n}\n\n.company-location {\n  font-size: 13px;\n  color: #777;\n}\n\n/* =================== Invoice Top =================== */\n.invoice-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between; /* لوگو راست، دکمه چپ */\n  gap: 20px;\n  flex-wrap: nowrap; /* همیشه کنار هم بمونن */\n  margin-bottom: 30px;\n}\n\n.invoice-logo {\n  order: 1;\n}\n\n.invoice-details {\n  order: 2;\n  flex: 1; /* کشیده میشه تا وسط قرار بگیره */\n  display: flex;\n  justify-content: center;\n  gap: 60px;\n  text-align: center;\n}\n\n.invoice-print-btn-container {\n  order: 3;\n}\n\n.invoice-print-btn {\n  background: #EA6C22;\n  color: #fff;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.invoice-print-btn:hover {\n  background: #d45a1d;\n}\n\n.invoice-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.invoice-col .label {\n  font-size: 12px;\n  color: #8790a6;\n  margin-bottom: 4px;\n}\n\n.invoice-col .value {\n  font-weight: 700;\n  font-size: 14px;\n  color: #222;\n}\n\n.payment-item {\n  background: #d8d8d8;\n  padding: 10px;\n  margin-bottom: 30px;\n  border-radius: 8px;\n}\n\n/* =================== Dashboard & Cards =================== */\n.dashboard-container {\n  display: flex;\n  flex-direction: column; \n  gap: 24px;\n  padding: 60px 20px;\n  background-color: #ffffff;\n  border-radius: 16px;\n  margin: 20px auto;\n  direction: rtl;\n  text-align: right;\n}\n\n.cards-row {\n  display: flex;\n  gap: 16px;\n}\n\n.card22 {\n  flex: 1;\n  padding: 20px;\n  border-radius: 12px;\n  background-color: #F6F8FC;\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  border: 1px solid #EBEFF6;\n  position: relative;\n}\n\n.label-cards {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #555;\n  margin-bottom: 16px;\n}\n\n.left-card {\n  background: linear-gradient(135deg, #ff7a45, #ff5c00);\n  color: white;\n  box-shadow: rgba(255, 89, 0, 0.5) 0px 18px 50px -10px;\n}\n\n.header33 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  direction: rtl;\n}\n\n.checkmark {\n  font-size: 14px;\n  color: #4CAF50;\n}\n\n.content {\n  text-align: right;\n}\n\n.amount {\n  font-size: 32px;\n  font-weight: bold;\n  margin: 10px 0;\n  text-align: center;\n  margin-top: 40px;\n}\n\n.count {\n  font-size: 14px;\n  opacity: 0.8;\n  margin-top: 8px;\n}\n\n.company-name,\n.support-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.contact-info,\n.phone,\n.address {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.5;\n  margin: 8px 0;\n}\n\n.address {\n  font-size: 12px;\n  color: #777;\n}\n\n.support-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.icon {\n  font-size: 18px;\n}\n\n/* =================== Pricing Table =================== */\n.uniqueTableWrapper_8kL2m {\n  max-width: 700px;\n  margin: 30px auto;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.07);\n  border: 1px solid #eef2f7;\n  font-family: 'Segoe UI', Tahoma, sans-serif;\n}\n\n.uniqueStyledTable_3pQ9r {\n  width: 100%;\n  border-collapse: collapse;\n  direction: rtl;\n}\n\n.uniqueStyledTable_3pQ9r th {\n  background: #f8fafc;\n  padding: 16px 20px;\n  text-align: center;\n  font-weight: 700;\n  color: #1e293b;\n  font-size: 15px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.uniqueStyledTable_3pQ9r td {\n  padding: 16px 20px;\n  text-align: center;\n  color: #475569;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.uniqueStyledTable_3pQ9r tr:last-child td {\n  border-bottom: none;\n}\n\n.uniqueStyledTable_3pQ9r tr:hover td {\n  background: #f9fafb;\n}\n\n.uniqueNameCell_7xR4t {\n  font-weight: 600;\n  color: #0f172a;\n  text-align: right !important;\n}\n\n.uniqueTotalCell_2aB8c {\n  font-weight: 700;\n  color: #0d9488;\n}\n\n/* =================== Responsive =================== */\n@media (max-width: 768px) {\n  .dashboard-container {\n    flex-direction: column;\n    padding: 12px;\n    gap: 20px;\n  }\n\n  .cards-row {\n    flex-direction: column; /* کارت‌ها زیر هم */\n    gap: 16px;\n  }\n\n  .card22 {\n    width: 100%;\n    padding: 16px;\n    min-height: auto;\n  }\n\n  .amount {\n    font-size: 24px;\n  }\n\n  .company-name,\n  .support-title {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 720px) {\n  .invoice-wrap {\n    padding: 16px;\n  }\n\n  .invoice {\n    padding: 20px;\n  }\n\n  .summary {\n    float: none;\n    width: 100%;\n  }\n\n  .invoice-top {\n    gap: 10px; /* کاهش فاصله */\n        flex-direction: column;\n\n  }\n\n  .invoice-details {\n    gap: 20px;\n        flex-direction: column;\n\n  }\n\n  .invoice-print-btn {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 600px) {\n  .uniqueStyledTable_3pQ9r,\n  .uniqueStyledTable_3pQ9r thead,\n  .uniqueStyledTable_3pQ9r tbody,\n  .uniqueStyledTable_3pQ9r th,\n  .uniqueStyledTable_3pQ9r td,\n  .uniqueStyledTable_3pQ9r tr {\n    display: block;\n  }\n\n  .uniqueStyledTable_3pQ9r thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .uniqueStyledTable_3pQ9r tr {\n    border: 1px solid #edf2f7;\n    margin-bottom: 12px;\n    border-radius: 12px;\n    padding: 16px;\n    background: #fff;\n  }\n\n  .uniqueStyledTable_3pQ9r td {\n    text-align: right !important;\n    border: none;\n    position: relative;\n    padding-right: 90px !important;\n    padding-left: 12px !important;\n    min-height: 26px;\n  }\n\n  .uniqueStyledTable_3pQ9r td:before {\n    content: attr(data-label) \": \";\n    position: absolute;\n    right: auto;\n    left: 12px;\n    font-weight: 600;\n    color: #475569;\n    font-size: 13px;\n  }\n\n  .uniqueNameCell_7xR4t:before {\n    color: #1e293b;\n  }\n\n  .uniqueTotalCell_2aB8c:before {\n    color: #0d9488;\n  }\n}\n\n\n\n\n\n.invoice-share-btn-container {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .invoice-share-btn-container {\n    display: block;\n    margin-top: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
